import { render, staticRenderFns } from "./Watch.vue?vue&type=template&id=7f8dbee7&scoped=true&"
import script from "./Watch.js?vue&type=script&lang=js&"
export * from "./Watch.js?vue&type=script&lang=js&"
import style0 from "./Watch.vue?vue&type=style&index=0&id=7f8dbee7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8dbee7",
  null
  
)

export default component.exports